import styles from "./Options.module.scss";

const Options = ({ setShowOptions, setShowViewRfq, byOrderIdData }) => {
  return (
    <div className={styles.options}>
      <ul>
        <li>
          <button
            className={styles.button}
            onClick={() => {
              setShowOptions(null);
              setShowViewRfq(true);
            }}
            disabled={byOrderIdData?.rfq}
          >
            View RfQ
          </button>
        </li>
      </ul>
    </div>
  );
};
export default Options;
